export const getLayout = ({
  showlegend,
  xaxis,
  yaxis,
  margin,
  legend,
  font,
  barmode,
  bargap,
  bargroupgap,
}: Partial<Plotly.Layout>) => ({
  autosize: true,
  font: { size: font?.size || 12, family: font?.family || 'Inter' },
  margin: {
    l: margin?.l ?? 15,
    r: margin?.r ?? 15,
    b: margin?.b ?? 90,
    t: margin?.t ?? 30,
  },
  xaxis: {
    automargin: true,
    type: xaxis?.type || 'category',
    showgrid: false,
    zeroline: false,
    tickvals: xaxis?.tickvals || undefined,
    ticktext: xaxis?.ticktext || undefined,
    title: {
      text: xaxis?.title?.text || '',
      standoff: 10,
    },
  },
  yaxis: {
    title: {
      text: yaxis?.title?.text || '',
      standoff: 20,
    },
    automargin: true,
    tickformat: ',d',
    rangemode: 'tozero',
    zeroline: true,
    range: yaxis?.range || undefined,
  },
  legend: {
    orientation: legend?.orientation || 'h',
    x: legend?.x || 0.5,
    y: legend?.y || -0.15,
    xanchor: legend?.xanchor || 'center',
    yanchor: legend?.yanchor || 'right',
  },
  barmode: barmode ?? 'stack',
  bargap: bargap ?? undefined,
  bargroupgap: bargroupgap ?? undefined,
  showlegend: showlegend ?? true,
  annotations: [
    {
      text: 'Source: Welligence Energy Analytics',
      xref: 'paper',
      yref: 'paper',
      x: 0.99,
      y: 0.98,
      xanchor: 'right',
      yanchor: 'top',
      showarrow: false,
      font: {
        size: 10,
        color: '#666666',
      },
    },
  ],
});
